import _isFunction from "lodash/isFunction";
var _excluded = ["value", "isTouched", "error", "onBlur", "onRemoveItem", "onDragOver", "onDragStart", "onDrop"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { formatShortText } from 'utils';
import { Button } from '../../Button';
import { Icon } from '../../Icon';
import Image from '../../Image';
import InputContainer from '../InputContainer';
import { useFileInput } from './useFileInput';
import { inputField, uploadWrap, fileInputContent, fileInputLabel, itemImageWrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FileInput = function FileInput(props) {
  var id = props.id,
      required = props.required,
      validate = props.validate,
      label = props.label,
      accept = props.accept,
      multiple = props.multiple,
      orderable = props.orderable,
      inputRef = props.inputRef;

  var _useFileInput = useFileInput(props),
      value = _useFileInput.value,
      isTouched = _useFileInput.isTouched,
      error = _useFileInput.error,
      onBlur = _useFileInput.onBlur,
      onRemoveItem = _useFileInput.onRemoveItem,
      _onDragOver = _useFileInput.onDragOver,
      _onDragStart = _useFileInput.onDragStart,
      _onDrop = _useFileInput.onDrop,
      inputAttr = _objectWithoutProperties(_useFileInput, _excluded);

  var hasValidation = _isFunction(validate) || required;

  var ContentContainer = function ContentContainer(_ref) {
    var children = _ref.children,
        itemId = _ref.id;
    return ___EmotionJSX("div", _extends({}, orderable && multiple && {
      id: itemId,
      draggable: true,
      onDragOver: function onDragOver(e) {
        return _onDragOver(e);
      },
      onDragStart: function onDragStart(e) {
        return _onDragStart(e);
      },
      onDrop: function onDrop(e) {
        return _onDrop(e);
      }
    }, {
      css: fileInputContent(props)
    }), children);
  };

  var contentLabel = function contentLabel(name) {
    return ___EmotionJSX("p", {
      css: fileInputLabel(props)
    }, formatShortText(name, 25));
  };

  var contentImage = function contentImage(image) {
    return ___EmotionJSX("div", {
      css: itemImageWrap
    }, ___EmotionJSX(Image, {
      src: image,
      width: 40,
      height: 40,
      background: true,
      size: "contain"
    }));
  };

  var removeIcon = function removeIcon(el) {
    return ___EmotionJSX("div", {
      role: "button",
      tabIndex: 0,
      onClick: function onClick() {
        return onRemoveItem(el);
      }
    }, ___EmotionJSX(Icon, {
      iconName: "la la-trash",
      color: "error",
      size: 22
    }));
  };

  return ___EmotionJSX(InputContainer, _extends({}, props, {
    error: error,
    isTouched: isTouched
  }), ___EmotionJSX("div", {
    css: uploadWrap(hasValidation, props)
  }, ___EmotionJSX("label", {
    htmlFor: id
  }, ___EmotionJSX(Button, {
    onClick: function onClick() {
      return window.addEventListener('focus', onBlur);
    }
  }, "Upload ", label)), ___EmotionJSX("input", _extends({
    ref: inputRef,
    id: id,
    type: "file",
    css: inputField,
    accept: accept
  }, inputAttr)), !!value && (multiple ? value.map(function (el) {
    var _el$data;

    return ___EmotionJSX(ContentContainer, {
      id: el === null || el === void 0 ? void 0 : el.__id,
      key: el === null || el === void 0 ? void 0 : el.__id
    }, removeIcon(el), contentLabel(el === null || el === void 0 ? void 0 : el.name), contentImage((_el$data = el === null || el === void 0 ? void 0 : el.data) !== null && _el$data !== void 0 ? _el$data : el === null || el === void 0 ? void 0 : el.url));
  }) : ___EmotionJSX(ContentContainer, null, contentLabel(value === null || value === void 0 ? void 0 : value.name), contentImage(value)))));
};

FileInput.propTypes = {
  inputRef: PropTypes.object,
  id: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onError: PropTypes.func,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
  validate: PropTypes.func,
  pattern: PropTypes.func,
  horizontal: PropTypes.bool,
  className: PropTypes.string,
  formId: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  orderable: PropTypes.bool
};
var InputRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(FileInput, _extends({}, props, {
    componentRef: ref
  }));
});
InputRef.displayName = 'FileInput';
export default InputRef;